import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FileIcon = (props: IconProps) => (
  <Icon width="17px" height="17px" viewBox="0 0 17 17" {...props}>
    <path d="M5.66671 11.3333H11.3334V12.75H5.66671V11.3333ZM5.66671 8.49996H11.3334V9.91663H5.66671V8.49996ZM9.91671 1.41663H4.25004C3.47087 1.41663 2.83337 2.05413 2.83337 2.83329V14.1666C2.83337 14.9458 3.46379 15.5833 4.24296 15.5833H12.75C13.5292 15.5833 14.1667 14.9458 14.1667 14.1666V5.66663L9.91671 1.41663ZM12.75 14.1666H4.25004V2.83329H9.20837V6.37496H12.75V14.1666Z" />
  </Icon>
);

export default memo(FileIcon);
